module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_c('span', {
    staticClass: "th11"
  }, [_vm._v("Mission Mistletoe")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("By Jessica Payseur")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Captain Archer Pfeil’s current assignment has been nothing but one long string of disasters. As if being dumped right before Christmas wasn’t enough, the mounting misfortunes indicate he’ll be out of a job by the end of his mission.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("But it’s difficult to salvage the assignment with Ambassador Ilin a’dlen Jhex around, pushing all Archer’s buttons. He struggles to keep his distance from the out-of-bounds ambassador, but Jhex has other plans in mind….")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47993f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/002.vue
// module id = 57
// module chunks = 0